import { combineReducers } from 'redux'

import { IUpgamingState } from '../types'
import communications from './communications'
import data from './data'

export const reducer = combineReducers<IUpgamingState>({
  communications,
  data,
})
